import { call, put, select, take, takeEvery } from 'redux-saga/effects';

import dynaForms, { getActions, getSelectors, getTypes } from '@elab/core/utils/dynaForms';
import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import { selectors as userSelectors } from '@elab/core/store/user';
import { actions as globalActions } from '@elab/core/store/global';
import { actions as uiActions } from '@elab/core/store/ui';
import { selectors as configSelectors } from '@elab/core/store/config';
import { passwordChangeFormSuccessMessage } from '@elab/core/utils/constants';
import { actions as authActions, types as authTypes } from '@elab/core/store/auth';

import api from './api';
import actions from './actions';
import selectors from './selectors';
import types from './types';

export function* login(password) {
    const uid = yield select(userSelectors.getDisplayUid);
    yield put(
        authActions.doLogin({
            username: uid,
            password,
            mergeCarts: false,
        }),
    );
    yield take(authTypes.LOGIN_DONE);
}

export function* redirectIfAble() {
    const shouldRedirect = yield select(configSelectors.redirectFromChangePassword);
    const successRedirectUrl = yield select(selectors.getSuccessRedirectLink);
    if (shouldRedirect && successRedirectUrl) {
        yield put(globalActions.redirect(successRedirectUrl));
    }
}

export function* resetFormIfAble() {
    const resetFormFields = yield select(configSelectors.resetPasswordFormFields);
    if (resetFormFields) {
        yield put(actions.resetFormData());
    }
}

export function* changePassword({ oldPassword, newPassword }) {
    const userId = yield select(userSelectors.getUserId);
    yield call(api.changePassword, oldPassword, newPassword, userId);
}

export function* doSubmit(dto) {
    yield call(changePassword, dto);
    yield call(resetFormIfAble);
    yield put(globalActions.addMessage(passwordChangeFormSuccessMessage));
    yield put(actions.setGlobalSuccess());
    yield call(login, dto.newPassword);
    yield call(redirectIfAble);
}

export function* preventSubmitOnLoading(action) {
    yield put(uiActions.preventClick(!!action.payload));
}

export default storeName => formId => {
    const reduxArtifacts = {
        types: getTypes(storeName),
        selectors: getSelectors(storeName),
        actions: getActions(storeName),
        storeName,
    };
    return [
        ...dynaForms.createSagaFor(
            reduxArtifacts,
            dynaFormsApi.getFormMetadata(formId || storeName),
            doSubmit,
            null,
            true,
        ),
        takeEvery(types.SET_LOADING, preventSubmitOnLoading),
    ];
};
